<template>
  <default>
    <main class="page page--profile">
      <slot name="header" />
      <div id="profile_tabs">
        <div class="mainWrap">
          <div class="row">
            <div class="col-12">
              <ul class="nav nav-tabs">
                <li
                  v-for="(option, index) in options"
                  :key="index"
                  class="nav-item"
                  :class="{ active: isActive(option.link) }"
                >
                  <StoreLink
                    class="nav-link py-3"
                    :class="{ active: isActive(option.link) }"
                    :href="option.link"
                    ><component
                      :is="option.icon"
                      class="me-2 mb-1"
                      size="24"
                    />{{ option.name }}</StoreLink
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="page page--profile mainWrap my-5 px-3 px-md-0">
        <div class="row">
          <div class="col-12">
            <slot />
          </div>
        </div>
      </div>
    </main>
  </default>
</template>

<script lang="ts" setup>
import Default from "~/layouts/default.vue";
import { useRoute } from "vue-router";
import type { Component } from "vue";
import StoreLink from "~/components/shared/buttons/StoreLink.vue";

// Define props for options (parent can pass this, otherwise default value is used later)
defineProps({
  options: {
    type: Array as PropType<{ name: string; link: string; icon: Component }[]>,
    required: true,
  },
});

const route = useRoute();

function isActive(link: string): boolean {
  return link === route.path;
}
</script>
<style lang="scss" scoped>
@use "@/sass/layouts/Profile.scss" as *;
</style>
